import { classifyPaymentValidationError, CheckoutErrorsEnum } from '@src/domains/payments';

export const TransactionErrorKind = {
  Declined: 'declined',
  Issuer: 'issuer',
  Blocked: 'blocked',
  Gateway: 'gateway',
} as const;

export type TransactionErrorKind = (typeof TransactionErrorKind)[keyof typeof TransactionErrorKind];

export const resolveTransactionError = (errors: { [key: string]: string[] }): TransactionErrorKind | null => {
  const { isBlockedBuyer, isGatewaysMismatch } = classifyPaymentValidationError(errors);

  if (isBlockedBuyer) {
    return TransactionErrorKind.Blocked;
  }

  if (isGatewaysMismatch) {
    return TransactionErrorKind.Gateway;
  }

  switch (errors['transactionError']?.[0]) {
    case CheckoutErrorsEnum.TRANSACTION:
      return TransactionErrorKind.Issuer;
    case CheckoutErrorsEnum.ANTIFRAUD:
    case CheckoutErrorsEnum.GENERIC:
      return TransactionErrorKind.Declined;
    default:
      return null;
  }
};
